<sk-banner-container></sk-banner-container>
<header sk-header></header>
<section class="sk-flex-page">
  <nav sk-platform-navigation></nav>
  <main class="sk-content-pane bg-light">
    <router-outlet></router-outlet>
  </main>
</section>